import React, { useState } from "react";
import arrowDown from "../assets/chevron-down.png";
const ChainSelection = ({
  options,
  images,
  onSelect,
  defaultValue,
  defaultImage,
  placeholder,
  className,
  icon,
}) => {
  const [selectedOption, setSelectedOption] = useState(defaultValue || "");
  const [selectedImage, setSelectedImage] = useState(defaultImage || "");
  const [open, setOpen] = useState(false);

  const handleOptionSelect = (option,image) => {
    setSelectedOption(option);
    handleOpenClose();
    onSelect && onSelect(option);
    setSelectedImage(image);
  };

  const handleOpenClose = () => {
    setOpen((pre) => !pre);
  };

  return (
    <div className="relative  block text-left   w-100 ">
      <div>
        <span className="rounded-[5px] shadow-sm">
          <button
            type="button"
            onClick={handleOpenClose}
            className={` text-res-xs flex items-center justify-center gap-[3px] rounded-[5px] px-[17px] py-[10px] font-bold capitalize bg-[#09090A] border-main-green border-[1px] relative w-full !h-[46px] text-main-white text-align-left  ${className}`}
            id="dropdown-menu"
            aria-haspopup="true"
            aria-expanded="true"
          >
          <img className="mr-2" style={{width:"19px",height:"19px",left:"16px", position:"absolute"}} src={"./assets/"+selectedImage+".png"}></img>
            <span style={{left:"43px", position:"absolute"}}>{selectedOption || placeholder}</span>
            <div style={{right:"10px", position:"absolute"}}>
              <img
                className={` ${
                  open ? "rotate-180" : "rotate-0"
                } transition-all`}
                src={icon || arrowDown}
                alt="arrowDown"
              />
            </div>
          </button>
        </span>
      </div>
      <div
        className={`absolute z-50 right-0 w-full origin-top-right  rounded-[5px] border border-main-green bg-[#09090A] capitalize    ring-black ring-opacity-5 ${
          !open ? "bottom-5 opacity-0" : ""
        }`}
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="dropdown-menu"
      >
        <div className="py-1" role="none">
          {options.map((option,i) => (
            <button
              key={option}
              onClick={() => handleOptionSelect(option,images[i])}
              style={{textAlign:"left"}}
              className="text-res-xs w-full px-4 py-2 capitalize hover:bg-gray-800 hover:opacity-70 font-bold flex flex-row"
              role="menuitem"
            >
              <img className="mr-2" style={{width:"17px",height:"17px"}} src={"./assets/"+images[i]+".png"}></img>
              {option}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChainSelection;
